// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, string } from 'prop-types'
import { ifObjectGetValue } from 'helpers/reduxFormFunctions'
import SortIcon from './SortIcon'

const Th = props => {
  const {
    columnHeader,
    columnHeaderTitle,
    columnKey,
    columnWidth,
    customProps,
    handleSort,
    headerFormatter,
    idRoot,
    sortable,
    tableSort,
    unitType,
  } = props

  const asc = !!ifObjectGetValue(tableSort, 'asc')
  const col = ifObjectGetValue(tableSort, 'col')

  const applySort = () => {
    if (sortable && handleSort) {
      handleSort(columnKey)
    }
  }

  const cellStyles = `th-${columnKey}${sortable ? ` pointer` : ``}`

  const thContent = (
    headerFormatter
      ? (
        <props.headerFormatter.default
          columnKey={columnKey}
          columnHeader={columnHeader}
          customProps={customProps}
          handleSort={handleSort}
          idRoot={`${idRoot}-${columnKey}-`}
          tableSort={tableSort}
          unitType={unitType} />
      ) : columnHeader
  )

  // the div:first-child here has a special role. div:last-child
  // is absolutely positioned to create a sticky form header. because
  // of this, the div:first-child is used to give width to the column
  return (
    <th
      className={cellStyles}
      id={`${idRoot}-${columnKey}`}
      onClick={applySort}
      style={{ width: columnWidth }}>
      <div>{thContent}</div>
      <div
        className={'bg-blue-dark'}
        title={columnHeaderTitle}>
        {thContent}
        <SortIcon
          asc={asc}
          showIcon={col === columnKey} />
      </div>
    </th>
  )
}

Th.propTypes = {
  columnHeader: string.isRequired,
  columnHeaderTitle: string,
  columnKey: string.isRequired,
  columnWidth: string,
  customProps: object,
  idRoot: string.isRequired,
  handleSort: func,
  headerFormatter: object,
  sortable: bool,
  tableSort: object,
  unitType: string,
}

export default Th
